const { abstractResource } = require('./abstractResource')

const service = abstractResource('PAYMENT')
const Bank = {
    get() {
        return service('banks').request({ params: { limit: 300 } })
    },
}
const Transaction = {
    get() {
        return service('transactions').request()
    },
}

module.exports = {
    Bank,
    Transaction,
}
